var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checklist-form',{staticClass:"pa-1",attrs:{"checklistId":_vm.checklistId,"formId":_vm.formId,"token":_vm.accessToken},on:{"update":_vm.onSuccessHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }